import { gateway } from '../../../gateway';
import { KanbanPage } from '../interfaces/kanbanPage.interface';

/**
 * Action to update the order of multiple kanban pages
 * 
 * Backend endpoint: PATCH /kanban-pages/self/reorder
 * Request body: { pageOrders: [{ pageId: string, order: number }] }
 * Response format: { status: 200, message: "Kanban pages reordered", data: KanbanPage[] }
 */
export const updateKanbanPagesOrderAction = async (
  pageOrders: { pageId: string; order: number }[]
): Promise<KanbanPage[]> => {
  try {
    if (!pageOrders || pageOrders.length === 0) {
      throw new Error('Page orders are required');
    }

    const response = await gateway.patch('/kanban-pages/self/reorder', {
      pageOrders,
    });

    // Backend returns { status, message, data } where data is the array of reordered pages
    const pages = response.data?.data || response.data;
    
    if (!Array.isArray(pages)) {
      throw new Error('Invalid response from server');
    }

    return pages;
  } catch (error: any) {
    console.error('Error reordering kanban pages:', error);
    // Extract error message from backend response
    const errorMessage = error?.response?.data?.message || error?.message || 'Failed to reorder kanban pages';
    throw new Error(errorMessage);
  }
};

